var lib_core = require("lib-core");
var SettingsStateMachine = require("ui-extensions").SettingsStateMachine;
var _ = require("underscore");
var cio_datamodel = require("cio-datamodel");
var cio_config = require("cio-config");
/**
 * @constructor
 */
var FootprintSettingsStateMachine = function (root, model) {
    var self = this;

    SettingsStateMachine.call(this, root, model);
};

if(typeof window !== 'undefined') {
    var ui_extensions = require("ui-extensions");
    lib_core.inherit(FootprintSettingsStateMachine, ui_extensions.SettingsStateMachine);
}

module.exports = FootprintSettingsStateMachine;

//Overwrite
FootprintSettingsStateMachine.prototype.verifySyncContentServer = function () {
    var self = this;
    var data = self.model.data;
    var header = this.root.header;
    var metaData = data.metaData();
    if(!header) return;
    self.root.dataLoader.dataManager.getResource(header["assetType"], header["assetId"])
    .then(function(contentServerData){
        var outOfSync = false;

        try {
            if(contentServerData["name"] != metaData.name()) {
                outOfSync = true;
            }
            if(contentServerData["summary"] != metaData.summary().replace(/\n/g,' ')) {
                outOfSync = true;
            }
            if(contentServerData["description"] != metaData.description().replace(/\n/g,' ')) {
                outOfSync = true;
            }
            if(!_.isEqual(contentServerData["tags"], metaData.tags.toArray())) {
                outOfSync = true;
            }

            var properties = cio_config.MetaProperties["footprint"];
            for(var key in properties){
                if(properties.hasOwnProperty(key) && contentServerData.properties)
                    if(metaData[key]() != contentServerData.properties[ properties[key].serverName ])
                        outOfSync = true;
            }

        } catch (err) {
            console.error(err);
            outOfSync = true;
        }

        if(outOfSync) {
            console.error("Content server out of sync with metadata in data model");
            //WARNING: Content server is delayed by a few seconds (updates of a previous session may not be reflected yet)
            // self.syncContentServer();
        }
    });
};

//override if needed
FootprintSettingsStateMachine.prototype.syncContentServer = function () {
    var self = this;
    var data = self.model.data;
    var header = this.root.header;
    var metaData = data.metaData();

    var props = cio_config.MetaProperties["footprint"];
    var propValues = {};
    for(var key in props){
        if(props.hasOwnProperty(key))
            propValues[props[key].serverName] = metaData[key]();
    }

    var resourceDescription = {
            "name": metaData.name(),
            "description": metaData.description(),
            "summary": metaData.summary(),
            "tags": metaData.tags.toArray(),
            "alias": metaData.alias(),
            "properties": propValues
    };

    return self.root.dataLoader.dataManager.updateResource(header["assetType"], header["assetId"], resourceDescription)
    .then(function(){
        console.log("syncContentServer done");
    });
    console.log("syncContentServer");
};
